export type PatternTargetBadgeBounds = {
    left: number
    right: number
    top: number
    bottom: number
}

export type PatternTargetBadgeLayout = {
    bounds: PatternTargetBadgeBounds
    tooltipAnchorX: number
    tooltipAnchorY: number
}

export type PatternTargetBadgePixelRatios = {
    horizontalPixelRatio: number
    verticalPixelRatio: number
}

export function measurePatternTargetBadgeLayout(
    targetPointX: number,
    targetPointY: number,
    ratios: PatternTargetBadgePixelRatios,
): PatternTargetBadgeLayout {
    const text = 'Target'
    const fontSize = 12 * ratios.verticalPixelRatio
    const padding = 4 * window.devicePixelRatio
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    let textWidth = 40
    let textHeight = 12
    if (ctx) {
        ctx.font = `${fontSize}px sans-serif`
        const measured = ctx.measureText(text)
        textWidth = measured.width
        textHeight = measured.actualBoundingBoxAscent + measured.actualBoundingBoxDescent
    }
    const boxW = textWidth + 2 * padding
    const boxH = textHeight + 2 * padding + 2 * window.devicePixelRatio
    const pointerSize = 6 * window.devicePixelRatio
    const gapY = 4 * window.devicePixelRatio
    const boxX = targetPointX - boxW - pointerSize * 0.75
    const boxY = targetPointY + gapY
    const pointerBaseX = boxX + boxW

    return {
        bounds: {
            left: boxX,
            right: Math.max(pointerBaseX, targetPointX),
            top: targetPointY,
            bottom: boxY + boxH,
        },
        tooltipAnchorX: boxX + boxW / 2,
        tooltipAnchorY: boxY,
    }
}

export function drawPatternTargetBadge(
    ctx: CanvasRenderingContext2D,
    targetPointX: number,
    targetPointY: number,
    badgeColor: string,
    ratios: PatternTargetBadgePixelRatios,
): PatternTargetBadgeLayout {
    const text = 'Target'
    const fontSize = 12 * ratios.verticalPixelRatio
    ctx.font = `${fontSize}px sans-serif`
    ctx.textBaseline = 'top'
    ctx.textAlign = 'left'
    ctx.globalAlpha = 1

    const padding = 4 * window.devicePixelRatio
    const dim = ctx.measureText(text)
    const textWidth = dim.width
    const textHeight = dim.actualBoundingBoxAscent + dim.actualBoundingBoxDescent
    const boxW = textWidth + 2 * padding
    const boxH = textHeight + 2 * padding + 2 * window.devicePixelRatio
    const pointerSize = 6 * window.devicePixelRatio
    const gapY = 4 * window.devicePixelRatio
    const boxX = targetPointX - boxW - pointerSize * 0.75
    const boxY = targetPointY + gapY
    const radius = 3 * ratios.horizontalPixelRatio
    const pointerBaseX = boxX + boxW
    const pointerBaseInsetX = boxX + boxW - pointerSize * 0.35
    const textX = boxX + padding
    const textY = boxY + padding

    ctx.fillStyle = badgeColor
    ctx.beginPath()
    ctx.roundRect(boxX, boxY, boxW, boxH, radius)
    ctx.fill()

    ctx.beginPath()
    ctx.moveTo(pointerBaseX, boxY)
    ctx.lineTo(targetPointX, targetPointY)
    ctx.lineTo(pointerBaseInsetX, boxY)
    ctx.closePath()
    ctx.fill()

    ctx.fillStyle = '#FFFFFF'
    ctx.fillText(text, textX, textY)

    return {
        bounds: {
            left: boxX,
            right: Math.max(pointerBaseX, targetPointX),
            top: targetPointY,
            bottom: boxY + boxH,
        },
        tooltipAnchorX: boxX + boxW / 2,
        tooltipAnchorY: boxY,
    }
}
